
import {defineComponent} from "vue";
import {StatusEnum} from "@/api/enums/status-enum";
import {ValueEnum} from "@/api/enums/value-enum";
import {AbilityContext} from "@/context/AbilityContext";
import {PropType} from "vue/dist/vue";
import {PopupOverviewRestDto} from "@/api/pharma-cms-popup/models";

export default defineComponent({
  name: "PopupOverviewItem",
  emits: ["delete", "updateStatus"],
  props: {
    popup: {
      type: Object as PropType<PopupOverviewRestDto>,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    this.reloadContent();
  },
  watch: {
  },
  computed: {
    StatusEnum() {
      return StatusEnum
    },
    canUpdatePopup(): boolean {
      return AbilityContext.isAuthorizedForFeature('POPUPS');
    },
  },
  methods: {
    updateStatus(id: string, status: ValueEnum) {
      if (this.canUpdatePopup) {
        this.$emit('updateStatus', id, status);
      }
    },
    async reloadContent() {
      // Do nothing?
    }
  }
});
